<template>
  <article class="message is-danger">
    <div class="message-header">
      <p>{{ $texts('accountNeeded', 'Benutzerkonto erforderlich') }}</p>
    </div>
    <div class="message-body">
      <p
        class="mb-4"
        v-html="
          $texts(
            'premiumAccountNeeded',
            'Um das Angebot zu nutzen, benötigen Sie ein Benutzerkonto und den Mitgliedsstatus <strong>Premium-Mitglied</strong>. Bitte wählen Sie zwischen den folgenden Optionen:',
          )
        "
      />
      <nuxt-link to="/user/register" class="button is-normal is-fullwidth mb-2"
        >{{ $texts('createNewAccount', 'Neues Konto anlegen') }}
      </nuxt-link>
      <nuxt-link
        :to="destinationLogin"
        class="button is-normal is-fullwidth mb-2"
        >{{ $texts('loginExistingAccount', 'Mit bestehendem Konto anmelden') }}
      </nuxt-link>
    </div>
  </article>
</template>

<script setup lang="ts">
const route = useRouter()
const { $texts } = useNuxtApp()

const destinationLogin = computed(() => {
  return '/user/login?destination=' + route.currentRoute.value.path
})
</script>
